import { productPricing } from "@/services/catalogService/contentBundle";
import { subscriptions } from "@/services/unauthService/subscriptions";

export default {
  namespaced: true,
  state: {
    prices: [],
    popularProduct: [],
    newProducts: [],
    isLoading: true,
  },
  getters: {
    prices: (state: any) => state.prices,
    isLoading: (state: any) => state.isLoading,
    singleTitleBundles: (state: any) => {
      return state.prices.filter((price: any) => price.is_single);
    },
    singleTitleBundlesNotFree: (state: any) => {
      return state.prices.filter(
        (price: any) => price.is_single && price.price > 0
      );
    },
    bundlePrices: (state: any) => {
      return state.prices.filter((price: any) => !price.is_single);
    },
    popularProduct: (state: any) => state.popularProduct,
    newProducts: (state: any) => state.newProducts,
  },
  mutations: {
    setPrices(state: any, value: any) {
      state.prices = value;
    },
    setLoading(state: any, value: boolean) {
      state.isLoading = value;
    },
    setPopularProduct(state: any, value: any) {
      state.popularProduct = value;
    },
    setNewProduct(state: any, value: any) {
      state.newProducts = value;
    },
  },
  actions: {
    async fetchPrices({ commit }: any) {
      await productPricing()
        .then((bundles) => {
          commit("content/setContentBundle", bundles, { root: true });
          commit("setPrices", bundles);
          commit("setLoading", false);
        })
        .catch(() => {
          // do nothing
        });
    },
    async fetchSubscriptions({ commit }: any) {
      await subscriptions()
        .then((bundles) => {
          commit("content/setContentBundle", bundles, { root: true });
          commit("setPrices", bundles);
          commit("setLoading", false);
        })
        .catch(() => {
          // do nothing
        });
    },
  },
};
